// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"f0cb4b3f","776":"f0cb4b3f","982":"f0cb4b3f"}[chunkId] + ".chunk.css";
};